
  import {
    Component,
    Vue,
    Inject,
    Prop,
    Watch,
    Ref
  } from "vue-property-decorator";
  import { ElForm } from "element-ui/types/form";
  import api from "@/api";
  import {
    PayrollRequisitionCreateOrEditDto,
    AuditFlowDto, IncomeRecordCreateOrEditDto, PaymentCategoryDto, PaymentCategoryScope
  } from "@/api/appService";
  import PaymentCategorySelect from "@/components/PaymentCategorySelect/index.vue";
  @Component({
    components: {PaymentCategorySelect}
  })
  export default class EditIncomeRecord extends Vue {
    @Ref() readonly dataForm!: ElForm;

    @Prop({default:0})
    dataId!:number;

    categories: PaymentCategoryDto[] = [];
    show = false;


    defaultData: IncomeRecordCreateOrEditDto = {
      /** 收入金额 */
      amount: 0,
      /** 入账日期 */
      incomeDate: undefined,
      /** 备注说明 */
      remark:'',
      /** 分类ID */
      categoryId:undefined,
      /**  */
      id:0
    };
    form: IncomeRecordCreateOrEditDto = { ...this.defaultData };

    async created(){
      await this.loadCategories();
    }

    get dialogTitle() {
      return this.form!.id ? "编辑" : "新建";
    }

    get scopeFilter(){
      return PaymentCategoryScope.IncomeRecord;
    }



    @Watch("show")
    async onShowChange(value: boolean) {
      if (value) {
        await api.incomeRecord
          .getForEdit({ id: this.dataId })
          .then(res => {
            this.form = res.data!;
          });
      } else {
        this.form = { ...this.defaultData };
      }
      this.$nextTick(() => {
        this.dataForm.clearValidate();
      });
    }

    async loadCategories(){
      await api.paymentCategoryService.getAll({maxResultCount:999999}).then(res=>{
        this.categories = res.items!;
      })
    }





    async save() {
      console.log(this.form);
      this.dataForm.validate(async (valid: boolean) => {
        if (valid) {
          if (this.form!.id) {
            await api.incomeRecord.update({ body: this.form });
          } else {
            await api.incomeRecord.create({ body: this.form });
          }
          this.show = false;
          this.$message.success("更新成功");
          this.$emit("onSave");
        }
      });
    }

    cancel() {
      this.show = false;
    }

    roleRule = {
      amount: [
        {
          required: true,
          message: "必填",
          trigger: "blur"
        }
      ],
      categoryId: [
        {
          required: true,
          message: "必填",
          trigger: "blur"
        }
      ],
      incomeDate: [
        {
          required: true,
          message: "必填",
          trigger: "blur"
        }
      ]
    };
  }
